// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2PBCr","title":"ClientReferral_title__2d99N","itemText":"ClientReferral_itemText__3f7rt"};